<template>
	<div id="notificationsAccountSettings" class="container-fluid">
		<div class="notification-save-header">
			<button class="btn unstyled"
							@click="save">
				<font-awesome-icon icon="save"></font-awesome-icon> {{ $t('commonText.save') }}
			</button>
		</div>
		<div class="alert"
				 :class="{'alert-success': responseType === 'success', 'alert-danger': responseType === 'danger'}"
				 style="margin-top: 10px;"
				 v-if="!!responseMessage">
			{{ responseMessage }}
		</div>
		<template v-if="dataIsLoaded">
			<div class="row">
				<div class="col-xs-12">
					<h4 class="text-blue">
						{{ $t('MAIN_CONTENT.Notifications.receiveNotificationsForTheFollowing') }}
					</h4>
					<p>
						{{ $t('MAIN_CONTENT.Notifications.turnOffNotificationsViaEmail') }}
					</p>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-6 col-lg-4" style="font-weight: bold;">
					<sapphire-toggle
						v-model="preferences.PREFERENCES.RECEIVE_BULLETIN_EMAIL_ALERTS"
						:value="preferences.PREFERENCES.RECEIVE_BULLETIN_EMAIL_ALERTS"
						:cssColors="true"
						@input="setPageDirty"
						:ariaLabel="$t( 'MAIN_CONTENT.Notifications.districtAnnouncements' )"
						:label="$t( 'MAIN_CONTENT.Notifications.districtAnnouncements' )"
					/>
				</div>
				<div class="col-xs-6 col-lg-4" style="font-weight: bold;">
					<sapphire-toggle
						v-model="preferences.PREFERENCES.RECEIVE_REPORT_EMAIL_ALERTS"
						:value="preferences.PREFERENCES.RECEIVE_REPORT_EMAIL_ALERTS"
						:cssColors="true"
						@input="setPageDirty"
						:ariaLabel="$t( 'MAIN_CONTENT.Notifications.studentClassReports' )"
						:label="$t( 'MAIN_CONTENT.Notifications.studentClassReports' )"
					/>
				</div>
			</div>
			<!-- Divider -->
			<hr />
			<!-- Tabs panel -->
			<shared-notifications
				v-if="!!options.GLOBAL_SETTINGS && options.GLOBAL_SETTINGS.length" :options="options"
				:preferences="preferences"
				:steps="steps"
				:broadcast="broadcasts"
				:globalSetting="globalSetting"
				:userType="role"
				:broadcastsData="broadcasts"
				:globalSettingText="$t( 'MAIN_CONTENT.Notifications.globalSetting' )"
				:emailText="$t( 'MAIN_CONTENT.Notifications.email' )"
				:voiceCallText="$t( 'MAIN_CONTENT.Notifications.voiceCall' )"
				:smsText="$t( 'MAIN_CONTENT.Notifications.sms' )"
				:notificationsText="$t( 'MAIN_CONTENT.Notifications.notificationsText' )"
				:subscribedText="$t( 'MAIN_CONTENT.Notifications.subscribed' )"
				:languageSettinsText="$t( 'MAIN_CONTENT.Notifications.languageSettings' )"
				:addNewStepText="$t( 'MAIN_CONTENT.Notifications.addNewStep' )"
				:defaultVoiceText="$t( 'MAIN_CONTENT.Notifications.defaultVoiceText' )"
				:defaultSMSText="$t( 'MAIN_CONTENT.Notifications.defaultSMSText' )"
				:defaultEmailText="$t( 'MAIN_CONTENT.Notifications.defaultEmailText' )"
				:broadcastHistoryText="$t( 'MAIN_CONTENT.Notifications.broadcastHistoryText' )"
				:noBroadcastMessage="$t( 'MAIN_CONTENT.Notifications.noBroadcastMessage' )"
				:phoneText="$t( 'MAIN_CONTENT.Notifications.phone' )"
				:answeredByText="$t( 'MAIN_CONTENT.Notifications.answeredBy' )"
				:durationsText="$t( 'MAIN_CONTENT.Notifications.duration' )"
				:phoneMessageText="$t( 'MAIN_CONTENT.Notifications.phoneMessage' )"
				:showEnglishText="$t( 'MAIN_CONTENT.Notifications.showEnglish' )"
				:noAudioSupportText="$t( 'MAIN_CONTENT.Notifications.noAudioSupport' )"
				:smsTextMessage="$t( 'MAIN_CONTENT.Notifications.smsTextMessage' )"
				:smsTestMessageColon="$t( 'MAIN_CONTENT.Notifications.smsTextMessageWithColon' )"
				:emailAllCaps="$t( 'MAIN_CONTENT.Notifications.emailAllCaps' )"
				:emailWithColon="$t( 'MAIN_CONTENT.Notifications.emailWithColon' )"
				:subjectLineWithColon="$t( 'MAIN_CONTENT.Notifications.subjectLineWithColon' )"
				:notificationsTabName="$t( 'MAIN_CONTENT.Notifications.notificationsTabName' )"
				:broadcastsTabName="$t( 'MAIN_CONTENT.Notifications.broadcastsTabName' )"
				:defaultWorkflowText="$t( 'MAIN_CONTENT.Notifications.defaultNotifications' )"
				:systemDefaultText="$t( 'MAIN_CONTENT.Notifications.systemDefault' )"
				:systemDefaultMessageText="$t( 'MAIN_CONTENT.Notifications.systemDefaultMessageText' )"
				:myDefaultText="$t( 'MAIN_CONTENT.Notifications.myDefault' )"
				:myDefaultMessageText="$t( 'MAIN_CONTENT.Notifications.myDefaultMessageText' )"
				:customText="$t( 'MAIN_CONTENT.Notifications.custom' )"
				:customMessageText="$t( 'MAIN_CONTENT.Notifications.customMessage' )"
				:addVoiceCallText="$t( 'MAIN_CONTENT.Notifications.addVoiceCall' )"
				:contactAtText="$t( 'MAIN_CONTENT.Notifications.contactAt' )"
				:addEmailText="$t( 'MAIN_CONTENT.Notifications.addEmail' )"
				:addSMSTextMessageText="$t( 'MAIN_CONTENT.Notifications.addSMSTextMessage' )"
				@changeGlobal="changeGlobalSetting"
				@setDirty="setPageDirty"
			/>
		</template>
	</div>
</template>

<script>
	import { Tabs, Tab } from 'vue-tabs-component';
	import Notifications from '../../../api/Notifications';
	import SharedNotifications from 'COMMONS/AccontSettings/SharedNotifications.vue';
	import SapphireToggle from 'COMMONS/SapphireToggle/SapphireToggle.vue';
	import { mapGetters } from 'vuex';

	export default {
		data() {
			return {
				steps:						0,
				dataIsLoaded:			false,
				isDirty:					false,
				globalSetting:		'S',
				responseType:			'',
				responseMessage:	'',
				options:					{},
				preferences:			{},
				broadcasts:				[]
			}
		},
		computed: {
			...mapGetters(['accessToken', 'role', 'selectedStudent', 'userIsAdmin', 'userGuid'])
		},
		components: {
			Tabs,
			Tab,
			SharedNotifications,
			SapphireToggle
		},
		methods: {
			loadPreferences() {
				const self = this;

				let notification = new Notifications({
					routeParams: { setting: 'all-preferences' },
					query: { 
						userGUID: this.userIsAdmin ? this.selectedStudent.STUDENT_USER_GUID : this.userGuid,
						type: self.role === 'student' ? 'S' : self.$store.state.role === 'admin' ? 'F' : 'C',
					}
				});

				const promise = notification.get();

				promise.then(response => {
					self.$set(self, 'preferences', notification.getResponseData());
					self.setGlobalSetting();
					self.loadOptions();
				})
				.catch(error => {
					console.log(error);
				});
			},
			loadOptions() {
				const self = this;

				let notification = new Notifications({
					routeParams: {
						setting: 'all-options'
					},
					query: {
						type: self.role === 'student' ? 'S' : self.$store.state.role === 'admin' ? 'F' : 'C',
						userGUID: this.userIsAdmin ? this.selectedStudent.STUDENT_USER_GUID : this.userGuid
					}
				});

				const promise = notification.get();

				promise.then(response => {
					self.$set(self, 'options', notification.getResponseData());
					self.loadBroadcast();
				})
				.catch(error => {
					console.log(error);
				});
			},
			loadBroadcast() {
				const self = this;

				let notification = new Notifications({
					routeParams: { setting: 'broadcasts' },
					query: { 
						include_details: 'Y',
						userGUID: this.userIsAdmin ? this.selectedStudent.STUDENT_USER_GUID : this.userGuid
					}
				});

				const promise = notification.get();

				promise.then(response => {
					self.$set(self, 'broadcasts', notification.getResponseData());
					self.dataIsLoaded = true;
				})
				.catch(error => {
					console.log(error);
				});
			},
			getTitle(type) {
				let title = !!type.NOTIFICATION_TYPE_DESC ? type.NOTIFICATION_TYPE_DESC : 'Default Notification Workflow';

				return title;
			},
			setGlobalSetting() {
				let setting = 'S';
				let subs = this.preferences.SUBSCRIPTIONS;
				let defaultWorkflowCount = 0;
				let customWorkflowCount = 0;

				for(let s in this.preferences.SUBSCRIPTIONS) {
					let subscription = this.preferences.SUBSCRIPTIONS[s];

					if(subscription.NOTIFICATION_TYPE_ID === 0) {
						defaultWorkflowCount = subscription.WORKFLOWS.length;
					} else {
						customWorkflowCount += subscription.WORKFLOWS.length;
					}
				}

				if(defaultWorkflowCount > 0 && customWorkflowCount === 0) {
					setting = 'D';
				} else if(customWorkflowCount > 0) {
					setting = 'C';
				}

				this.$set(this, 'globalSetting', setting);
			},
			changeGlobalSetting(value) {
				this.globalSetting = value;
				this.setPageDirty();
			},
			setPageDirty() {
				this.isDirty = true;
				this.responseMessage = '';
			},
			save() {
				const self = this;

				let notification = new Notifications({
					routeParams: { setting: 'all-preferences' },
					data: {
						global_setting:	self.globalSetting,
						preferences:		self.preferences.PREFERENCES,
						settings:				self.preferences.SETTINGS,
						subscriptions:	self.preferences.SUBSCRIPTIONS
					},
					query:{
						userGUID: this.userIsAdmin ? this.selectedStudent.STUDENT_USER_GUID : this.userGuid,
						studentRid: !!this.selectedStudent > 0 ?
							this.selectedStudent.STUDENT_RID :
							''
					}
				});

				const promise = notification.put();

				promise.then(response => {
					self.responseType = notification.getResponseData().TYPE;
					self.responseMessage = notification.getResponseData().TEXT;
					self.isDirty = false;
					self.loadPreferences();
				});
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'bell');
			this.$store.commit('setTitle', this.$t('MAIN_CONTENT.Notifications.notifications'));
			this.$store.commit('setUseHeader', true);

			this.loadPreferences();
		},
		beforeRouteLeave(to, from, next) {
			// called when the route that renders this component has changed,
			// but this component is reused in the new route.
			// For example, for a route with dynamic params `/foo/:id`, when we
			// navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
			// will be reused, and this hook will be called when that happens.
			// has access to `this` component instance.
			const self = this;

			if( self.isDirty ) {
				const message = self.$t('MAIN_CONTENT.Notifications.dirtyPageMessage');
				const options = {
					title: self.$t('MAIN_CONTENT.Notifications.dirtyPageTitle'),
					okText: self.$t('MAIN_CONTENT.Notifications.dirtyPageOkText'),
					cancelText: self.$t('MAIN_CONTENT.Notifications.dirtyPageCancelText')
				};
				self.$modal.confirm(message, options)
					.then(function(dialog) {
						next();
					});
			} else {
				next();
			}
		}
	}
</script>

<style scoped>
	.notification-save-header {
		text-align: right;
		padding-bottom: 5px;
		padding-top: 5px;
		margin-right: -5px;
		margin-left: -5px;
		background-color: #0D76BE;
	}

	.unstyled {
		margin-right: 15px;
		background-color: unset;
		color: white;
	}
</style>
